import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const scrollToForm = () => {
    document.getElementById('contact-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={scrollToForm} className={`inline-flex items-center justify-center px-8 py-4 text-carbon font-bold text-lg md:text-xl bg-gold hover:bg-gold-light transition-all duration-300 rounded-sm shadow-[0_0_15px_rgba(242,183,5,0.2)] hover:shadow-[0_0_25px_rgba(242,183,5,0.4)] hover:-translate-y-1 text-center ${className}`} data-id="element-194">
      {children}
    </button>;
}